import React from 'react';
import type { IconProps } from './types';

export const Verify = ({ onClick }: IconProps) => (
  <div role="none" className="icon icon-verify" onClick={onClick}>
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.18993 12.117L12.7992 7.50769C12.9976 7.30936 12.9976 6.98878 12.7992 6.79045C12.6014 6.59212 12.2803 6.59212 12.082 6.79045L7.83131 11.0411L5.88553 9.09536C5.6872 8.89703 5.36612 8.89703 5.16778 9.09536C4.96996 9.29369 4.96996 9.61427 5.16778 9.8126L7.47269 12.117C7.57161 12.2159 7.70146 12.2656 7.83131 12.2656C7.96117 12.2656 8.09102 12.2159 8.18993 12.117ZM9 0C4.02903 0 0 4.03004 0 9C0 13.971 4.02903 18.0005 9 18.0005C13.9705 18.0005 18 13.971 18 9C18 4.03004 13.9705 0 9 0ZM9 1.01448C13.4029 1.01448 16.9855 4.59714 16.9855 9C16.9855 13.4034 13.4029 16.986 9 16.986C4.59663 16.986 1.01448 13.4034 1.01448 9C1.01448 4.59714 4.59663 1.01448 9 1.01448Z"
        fill="#FC4C02"
      />
    </svg>
  </div>
);
